export default "__VITE_ASSET__QIFiCelt__"